import { Currency } from "./currency.type";
import { Kind } from "./order.type";

export enum CommissionRequestStatus {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected",
}

export interface ICommissionRequest {
  _id: string;
  orderId: string;
  salesUserId: string | {
    _id: string;
    name: string;
    username?: string;
  };
  salesUserName: string;
  orderReceipt: string;
  clientName: string;
  itemName: string;
  itemKind: Kind;
  itemKindId: string;
  unitOfMeasurement: string;
  salePrice: number;
  minPrice: number;
  quantity: number;
  currency: Currency;
  exchangeRate: number;
  marginPerUnit: number;
  totalMargin: number;
  commissionAmount: number;
  commissionInUZS: number;
  tariffRuleName?: string;
  tariffRulePercent?: number;
  status: CommissionRequestStatus;
  approvedBy?: string | {
    _id: string;
    name: string;
  };
  approvedAt?: string;
  approvalNotes?: string;
  rejectedBy?: string | {
    _id: string;
    name: string;
  };
  rejectedAt?: string;
  rejectionReason?: string;
  createdAt: string;
  updatedAt: string;
}

